import activityLog from './activityLog'
import appErrors from './appErrors'
import auth from './auth'
import common from './common'
import dataExportView from './dataExportView'
import dataImportView from './dataImportView'
import dataView from './dataView'
import emails from './emails'
import guest from './guest'
import homeView from './homeView'
import jobs from './jobs'
import jobMonitorView from './jobMonitorView'
import messageView from './messageView'
import nodeDefEdit from './nodeDefEdit'
import surveyCreate from './surveyCreate'
import surveyForm from './surveyForm'
import surveyCompareView from './surveyCompareView'
import systemLogsView from './systemLogsView'
import userAiSettings from './userAiSettings'
import user2FADevice from './user2FADevice'
import usersView from './usersView'
import validationErrors from './validationErrors'
import whatsNew from './whatsNew'

export default {
  activityLog,
  appErrors,
  auth,
  common,
  dataExportView,
  dataImportView,
  dataView,
  emails,
  guest,
  homeView,
  jobs,
  jobMonitorView,
  messageView,
  nodeDefEdit,
  surveyCreate,
  surveyForm,
  surveyCompareView,
  systemLogsView,
  userAiSettings,
  user2FADevice,
  usersView,
  validationErrors,
  whatsNew,
}
